import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/index'
import store from '@/store';
import Notifications from 'vue-notification'
import { Buffer } from 'buffer'
import VueSvgInlinePlugin from "vue-svg-inline-plugin";
import "@/scss/_global.scss";

Vue.use(Notifications)
Vue.use(VueSvgInlinePlugin);

Vue.config.productionTip = false
window.Buffer = Buffer;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
